<template>
  <div class="order-list-wrap">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="search-row">
        <div class="search-item">
          <label>创建起止时间：</label>
          <div class="date-range">
            <input type="date" v-model="searchForm.startDate" class="date-input" />
            <span class="date-sep">至</span>
            <input type="date" v-model="searchForm.endDate" class="date-input" />
          </div>
        </div>
        <div class="search-item">
          <label>被保人姓名：</label>
          <input type="text" v-model="searchForm.insuredName" class="text-input" placeholder="请输入被保险人" />
        </div>
        <div class="search-item">
          <label>保单号：</label>
          <input type="text" v-model="searchForm.policyCode" class="text-input" placeholder="请输入保单号" />
        </div>
        <div class="search-item">
          <label>被保人证件号：</label>
          <input type="text" v-model="searchForm.insuredCertNo" class="text-input" placeholder="请输入被保人证件号" />
        </div>
        
        <div class="search-item">
          <label>投保单号：</label>
          <input type="text" v-model="searchForm.insurerApplyPolicyNo" class="text-input" placeholder="请输入投保单号" />
        </div>
        <div class="search-item">
          <label>订单状态：</label>
          <select v-model="searchForm.orderStatus" class="select-input">
            <option value="">全部</option>
            <option value="0">待支付</option>
            <option value="1">已取消</option>
            <option value="2">待承保</option>
            <option value="3">承保失败</option>
            <option value="4">已承保</option>
            <option value="5">已退保</option>
            <option value="6">已退款</option>
          </select>
        </div>
        <div class="search-item">
          <label>支付模式：</label>
          <select v-model="searchForm.payMode" class="select-input">
            <option value="">全部</option>
            <option value="0">非见费</option>
            <option value="1">见费出单</option>
            <option value="2">预缴费</option>
          </select>
        </div>
        <div class="search-buttons">
          <button class="btn btn-primary" @click="handleSearch">查询</button>
          <button class="btn btn-default" @click="handleReset">重置</button>
          <button class="btn btn-export" @click="handleExport" :disabled="exporting">{{ exporting ? '导出中...' : '导出' }}</button>
        </div>
      </div>
    </div>

    <!-- 订单表格 -->
    <div class="table-wrapper" v-if="orderList.length > 0">
      <table class="order-table">
        <thead>
          <tr>
            <th>投保单单号</th>
            <th>保单号</th>
            <th>投保单位</th>
            <th>创建时间</th>
            <th>产品名称</th>
            <th>订单状态</th>
            <th>支付模式</th>
            <th>保障期限</th>
            <th>保费金额</th>
            <th class="col-action">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orderList" :key="order.orderCode || order.insurerApplyPolicyNo || order.id">
            <td>{{ order.insurerApplyPolicyNo }}</td>
            <td>{{ order.policyCode }}</td>
            <td>{{ order.policyholderName }}</td>
            <td>{{ order.createTime }}</td>
            <td>{{ order.productName }}</td>
            <td>
              <span class="status-tag" :class="getStatusClass(order.orderStatus !== undefined ? order.orderStatus : order.coverStatus)">
                {{ order.orderStatusStr || order.coverStatusStr }}
              </span>
            </td>
            <td>{{ getPayModeText(order) }}</td>
            <td>{{ order.insureStartDate }} 至 {{ order.insureEndDate }}</td>
            <td>{{ order.premium }}</td>
            <td class="col-action">
              <a class="row-action" @click.prevent="viewOrder(order)">详情</a>
              <a class="row-action" @click.prevent="exportInsured(order)" :class="{ 'row-action-disabled': exportingInsuredId === order.id }">导出</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 订单空状态 -->
    <div class="empty-state" v-else>
      <v-icon size="64" color="#ddd">description</v-icon>
      <p class="empty-text">暂无订单记录</p>
    </div>

    <!-- 订单分页 -->
    <div class="pagination-wrapper" v-if="orderList.length > 0">
      <v-pagination
        v-model="orderCurrentPage"
        :length="orderTotalPages"
        :total-visible="7"
        color="#dd122a"
        @input="handleOrderPageChange"
      ></v-pagination>
    </div>

    <!-- 订单详情弹窗（被保人清单） -->
    <OrderDetailDialog ref="orderDetailDialog" />
  </div>
</template>

<script>
import { getOrderList, exportOrder, exportOrderInsuredList } from '@/api/travelInsurance';
import OrderDetailDialog from './orderDetailDialog.vue';

export default {
  name: 'OrderManagement',
  components: { OrderDetailDialog },
  data() {
    return {
      // 订单列表
      orderList: [],
      orderCurrentPage: 1,
      orderPageSize: 10,
      orderTotalPages: 1,
      orderTotalCount: 0,

      // 搜索条件
      searchForm: {
        startDate: '',
        endDate: '',
        insuredName: '',
        insuredCertNo: '',
        policyCode: '',
        insurerApplyPolicyNo: '',
        orderStatus: '',
        payMode: ''
      },

      // 导出状态
      exporting: false,
      exportingInsuredId: null,
    };
  },
  mounted() {
    this.loadOrderList();
  },
  methods: {
    // 组装搜索参数（仅保留非空条件）
    buildSearchParams() {
      const f = this.searchForm;
      const params = {};
      if (f.startDate) params.startCreateTime = f.startDate;
      if (f.endDate) params.endCreateTime = f.endDate;
      if (f.insuredName) params.insuredName = f.insuredName;
      if (f.insuredCertNo) params.insuredCertNo = f.insuredCertNo;
      if (f.policyCode) params.policyCode = f.policyCode;
      if (f.insurerApplyPolicyNo) params.insurerApplyPolicyNo = f.insurerApplyPolicyNo;
      if (f.orderStatus !== '') params.orderStatus = Number(f.orderStatus);
      if (f.payMode !== '') params.payMode = Number(f.payMode);
      return params;
    },

    // 加载订单列表
    async loadOrderList() {
      try {
        const params = {
          pageIndex: this.orderCurrentPage,
          pageSize: this.orderPageSize,
          ...this.buildSearchParams()
        };
        const res = await getOrderList(params);
        if (res.code === 0 || res.success) {
          const pageData = res.data || {};
          this.orderList = pageData.records || [];
          this.orderTotalCount = pageData.total || 0;
          this.orderTotalPages = pageData.pages || 1;
        } else {
          this.$message.error(res.msg || '获取订单列表失败');
          this.orderList = [];
        }
      } catch (error) {
        console.error('获取订单列表失败:', error);
        this.$message.error('获取订单列表失败');
        this.orderList = [];
      }
    },

    // 查询
    handleSearch() {
      this.orderCurrentPage = 1;
      this.loadOrderList();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        startDate: '',
        endDate: '',
        insuredName: '',
        insuredCertNo: '',
        policyCode: '',
        insurerApplyPolicyNo: '',
        orderStatus: '',
        payMode: ''
      };
      this.orderCurrentPage = 1;
      this.loadOrderList();
    },

    // 导出订单
    async handleExport() {
      this.exporting = true;
      try {
        const res = await exportOrder(this.buildSearchParams());
        if (res && res.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result);
              this.$message.error(err.msg || '导出失败');
            } catch (e) {
              this.$message.error('导出失败');
            }
          };
          reader.readAsText(res);
          return;
        }
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `订单列表_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('导出订单失败:', error);
        this.$message.error('导出订单失败');
      } finally {
        this.exporting = false;
      }
    },

    // 订单分页变化
    handleOrderPageChange(page) {
      this.orderCurrentPage = page;
      this.loadOrderList();
    },

    // 查看订单（打开被保人清单弹窗）
    viewOrder(order) {
      this.$refs.orderDetailDialog.open(order);
    },

    // 导出订单被保人列表
    async exportInsured(order) {
      const key = order.id;
      // 防重复点击
      if (this.exportingInsuredId === key) return;
      const orderId = order.id;
      if (orderId == null) {
        this.$message.error('缺少订单ID，无法导出');
        return;
      }
      this.exportingInsuredId = key;
      try {
        const res = await exportOrderInsuredList({ id: Number(orderId) });
        if (res && res.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result);
              this.$message.error(err.msg || '导出失败');
            } catch (e) {
              this.$message.error('导出失败');
            }
          };
          reader.readAsText(res);
          return;
        }
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `被保人列表_${orderId}_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('导出被保人列表失败:', error);
        this.$message.error('导出被保人列表失败');
      } finally {
        this.exportingInsuredId = null;
      }
    },

    // 获取状态样式类
    // 订单状态：0待支付 1已取消 2待承保 3承保失败 4已承保 5已退保 6已退款
    getStatusClass(status) {
      const statusMap = {
        0: 'status-warning',
        1: 'status-canceled',
        2: 'status-pending',
        3: 'status-error',
        4: 'status-active',
        5: 'status-canceled',
        6: 'status-refunded'
      };
      return statusMap[status] || '';
    },

    // 支付模式文本映射：0非见费 1见费出单 2预缴费
    getPayModeText(order) {
      if (order.payModeStr) return order.payModeStr;
      const map = { 0: '非见费', 1: '见费出单', 2: '预缴费' };
      const v = order.payMode;
      if (v === undefined || v === null || v === '') return '-';
      return map[v] !== undefined ? map[v] : (map[Number(v)] !== undefined ? map[Number(v)] : v);
    },
  }
};
</script>

<style lang="scss" scoped>
.order-list-wrap {
  width: 100%;
}

// 搜索栏
.search-bar {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 20px 24px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px 32px;
  }

  .search-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    label {
      font-size: 13px;
      color: #666;
      white-space: nowrap;
    }

    .text-input,
    .select-input,
    .date-input {
      width: 180px;
      height: 36px;
      padding: 0 10px;
      border: 1px solid #D9D9D9;
      border-radius: 4px;
      font-size: 14px;
      color: #262626;
      background: #fff;
      outline: none;
      transition: border-color 0.15s;

      &:focus {
        border-color: #dd122a;
      }
    }

    .date-range {
      display: flex;
      align-items: center;
      gap: 8px;

      .date-sep {
        color: #999;
        font-size: 13px;
      }
    }
  }

  .search-buttons {
    display: flex;
    align-items: center;
    gap: 12px;

    .btn {
      height: 36px;
      padding: 0 20px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid transparent;
      transition: opacity 0.15s, background-color 0.15s;

      &[disabled] {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .btn-primary {
      background-color: #dd122a;
      color: #fff;

      &:hover {
        opacity: 0.9;
      }
    }

    .btn-default {
      background-color: #fff;
      border-color: #D9D9D9;
      color: #595959;

      &:hover {
        border-color: #dd122a;
        color: #dd122a;
      }
    }

    .btn-export {
      background-color: #fff;
      border-color: #dd122a;
      color: #dd122a;

      &:hover {
        background-color: #dd122a;
        color: #fff;
      }
    }
  }
}

// 表格容器
.table-wrapper {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow-x: auto;
  margin-bottom: 20px;
}

// 订单表格
.order-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead {
    background-color: #F5F5F5;

    th {
      padding: 14px 12px;
      text-align: left;
      font-weight: 500;
      color: #333;
      white-space: nowrap;
      border-bottom: 1px solid #E8E8E8;

      &.col-action {
        position: sticky;
        right: 0;
        z-index: 3;
        background-color: #F5F5F5;
        text-align: center;
        box-shadow: -4px 0 6px -4px rgba(0, 0, 0, 0.08);
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #F0F0F0;
      transition: background-color 0.2s;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #FAFAFA;

        td.col-action {
          background-color: #FAFAFA;
        }
      }
    }

    td {
      padding: 14px 12px;
      color: #262626;
      white-space: nowrap;

      &.col-action {
        position: sticky;
        right: 0;
        z-index: 1;
        background-color: #fff;
        text-align: center;
        box-shadow: -4px 0 6px -4px rgba(0, 0, 0, 0.08);
      }
    }
  }
}

// 状态徽标
.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;

  &.status-pending {
    background-color: #DBEAFE;
    color: #007DFF;
  }

  &.status-active {
    background-color: #DCFCE8;
    color: #18813E;
  }

  &.status-expired {
    background-color: #FDF1F2;
    color: #DD122A;
  }

  &.status-canceled {
    background-color: #EEEEEE;
    color: #93969B;
  }

  &.status-warning {
    background-color: #FFF7E6;
    color: #D46B08;
  }

  &.status-error {
    background-color: #FDF1F2;
    color: #DD122A;
  }

  &.status-refunded {
    background-color: #F0F0F0;
    color: #666666;
  }
}

// 行内操作文字链接
.row-action {
  display: inline-block;
  margin: 0 8px;
  color: #007DFF;
  cursor: pointer;
  font-size: 13px;
  text-decoration: none;
  transition: color 0.15s;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: #005BB5;
    text-decoration: underline;
  }

  &.row-action-disabled {
    color: #bfbfbf;
    cursor: not-allowed;
    text-decoration: none;

    &:hover {
      color: #bfbfbf;
      text-decoration: none;
    }
  }
}

// 空状态
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background-color: #fff;
  border-radius: 8px;

  .empty-text {
    margin-top: 16px;
    font-size: 14px;
    color: #999;
  }
}

// 分页
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
}
</style>
